"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffersDetailColumns = exports.getOffersOverviewColumns = void 0;
const react_1 = __importDefault(require("react"));
const dateformat_1 = require("../../common/js/helper/dateformat");
const number_1 = require("../../common/js/helper/number");
const translation_1 = require("../../common/js/helper/translation");
const AssetsOfferCheckout_1 = __importDefault(require("../components/assets/AssetsOfferCheckout"));
const UiStore_1 = __importDefault(require("../stores/UiStore"));
const money_1 = require("./money");
// Using callback functions for all columns to ensure everything is translated correctly after language switch.
const OfferId = () => ({
    name: (0, translation_1.t)('myassets.offer.table.offer_id.column_name'),
    sortable: true,
    selector: (offer) => offer.offerId,
    format: (offer) => (react_1.default.createElement("div", { className: "--white-space-normal my-2 znd-table-tile__name" }, offer.offerId)),
});
const OfferDate = () => ({
    name: (0, translation_1.t)('myassets.offer.table.offer_date.column_name'),
    sortable: true,
    selector: (offer) => offer.offerEndDate?.valueOf() ?? 0,
    format: (offer) => (0, dateformat_1.getDateFormat)(offer.offerEndDate),
});
const Price = () => {
    const showPrice = (offer) => !!offer.price &&
        offer.items.some((item) => {
            return getItemPrice(item);
        });
    return {
        name: (0, translation_1.t)('myassets.offer.table.price.column_name'),
        sortable: true,
        selector: (offer) => (showPrice(offer) ? offer.price : 0),
        format: (offer) => (react_1.default.createElement("div", { className: "--white-space-normal my-2 znd-table-tile__name" }, showPrice(offer) ? (0, money_1.moneyFormat)(offer.price, offer.currencyCode) : null)),
    };
};
const Checkout = () => ({
    minWidth: '16rem',
    name: '',
    sortable: false,
    cell: (offer) => react_1.default.createElement(AssetsOfferCheckout_1.default, { offer: offer }),
});
const defaultColumnsCallback = () => [
    OfferId(),
    OfferDate(),
    Price(),
    Checkout(),
];
const getOffersOverviewColumns = () => defaultColumnsCallback();
exports.getOffersOverviewColumns = getOffersOverviewColumns;
const Name = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('myassets.offer.table.name.column_name'),
    sortable: false,
    cell: (offerItem) => (react_1.default.createElement("div", { className: "--white-space-normal my-2 znd-table-tile__name" }, offerItem.translations[UiStore_1.default.language] ?? offerItem.productId)),
});
const LicenseCount = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('myassets.offer.table.license_count.column_name'),
    sortable: false,
    cell: (offerItem) => (react_1.default.createElement("div", { className: "--white-space-normal my-2 znd-table-tile__name" }, offerItem.licenseCount ? (0, number_1.numberFormat)(offerItem.licenseCount) : null)),
});
const LicenseId = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('myassets.offer.table.license_id.column_name'),
    sortable: false,
    cell: (offerItem) => (react_1.default.createElement("div", { className: "--white-space-normal my-2 znd-table-tile__name" }, offerItem.licenseId)),
});
const EndDate = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('myassets.offer.table.end_date.column_name'),
    sortable: false,
    cell: (offerItem) => (0, dateformat_1.getDateFormat)(offerItem.endDate),
});
const MachineSerialNumber = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('myassets.offer.table.machine_serial_number.column_name'),
    sortable: false,
    cell: (offerItem) => (react_1.default.createElement("div", { className: "--white-space-normal my-2 znd-table-tile__name" }, offerItem.machineSerialNumber)),
});
const PriceOfferItem = () => ({
    allowOverflow: true,
    name: (0, translation_1.t)('myassets.offer.table.price.column_name'),
    sortable: false,
    right: true,
    cell: (offerItem) => {
        return getItemPrice(offerItem);
    },
});
const getItemPrice = (item) => {
    if ((item.orderedAt ?? null) !== null) {
        return null;
    }
    return item.price ? (0, money_1.moneyFormat)(item.price, item.currencyCode) : null;
};
const getOffersDetailColumns = () => {
    return [Name(), LicenseCount(), LicenseId(), EndDate(), MachineSerialNumber(), PriceOfferItem()];
};
exports.getOffersDetailColumns = getOffersDetailColumns;
